import client from './client';

export enum OrderStatus {
  PENDING_PAYMENT = 'pending_payment',
  CONFIRMED = 'confirmed',
  PACKING = 'packing',
  READY_FOR_PICKUP = 'ready_for_pickup',
  IN_DELIVERY = 'in_delivery',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected',
}

export enum PaymentStatus {
  PENDING = 'pending',
  AWAITING_CONFIRMATION = 'awaiting_confirmation',
  COMPLETED = 'completed',
  FAILED = 'failed',
  REFUNDED = 'refunded',
}

export interface OrderItem {
  id: number;
  order_id: number;
  product_id: number;
  quantity: number;
  price_at_order: number;
  subtotal: number;
  created_at: string;
}

export interface Order {
  id: number;
  customer_id: number;
  store_id: number;
  status: OrderStatus;
  payment_status: PaymentStatus;
  delivery_address: string;
  delivery_latitude?: number;
  delivery_longitude?: number;
  special_instructions?: string;
  subtotal: number;
  delivery_fee: number;
  discount_amount: number;
  total_amount: number;
  items: OrderItem[];
  created_at: string;
  confirmed_at?: string;
  delivered_at?: string;
}

export interface CreateOrderRequest {
  store_id: number;
  delivery_address: string;
  delivery_latitude?: number;
  delivery_longitude?: number;
  special_instructions?: string;
  delivery_fee?: number;
  discount_amount?: number;
  coupon_code?: string;
}

export const ordersAPI = {
  async createOrder(orderData: CreateOrderRequest): Promise<Order> {
    const { data } = await client.post<Order>('/api/orders', orderData);
    return data;
  },

  async getOrder(orderId: number): Promise<Order> {
    const { data } = await client.get<Order>(`/api/orders/${orderId}`);
    return data;
  },

  async listOrders(skip: number = 0, limit: number = 50): Promise<Order[]> {
    const { data } = await client.get<Order[]>(
      `/api/orders?skip=${skip}&limit=${limit}`
    );
    return data;
  },

  async cancelOrder(orderId: number): Promise<any> {
    const { data } = await client.patch(`/api/orders/${orderId}/cancel`);
    return data;
  },

  async getOrdersByStore(
    storeId: number,
    status?: string,
    skip: number = 0,
    limit: number = 50
  ): Promise<Order[]> {
    let url = `/api/orders/store/${storeId}/orders?skip=${skip}&limit=${limit}`;
    if (status) {
      url += `&status=${status}`;
    }
    const { data } = await client.get<Order[]>(url);
    return data;
  },

  async updateOrderStatus(orderId: number, newStatus: string): Promise<Order> {
    const { data } = await client.patch<Order>(
      `/api/orders/${orderId}/status?new_status=${newStatus}`
    );
    return data;
  },

  async getStoreOrderStats(storeId: number): Promise<{
    total_orders: number;
    confirmed_orders: number;
    cancelled_orders: number;
    total_revenue: number;
  }> {
    const { data } = await client.get(
      `/api/orders/store/${storeId}/stats`
    );
    return data;
  },
};
